const simpleDDP = require("simpleddp"); // nodejs
const ws = require("isomorphic-ws");

let opts = {
  endpoint: "wss://amo.inside.me/websocket",
  SocketConstructor: ws,
  reconnectInterval: 5000
};
export const server = new simpleDDP(opts);
